import React from "react";
import { AlertTriangle, X, Trash2, RefreshCcw } from "lucide-react";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  itemName: string;
  loading?: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  itemName,
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center bg-black/60 backdrop-blur-md p-4 animate-in fade-in duration-300">
      <div className="bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden animate-in zoom-in-95 duration-200">
        <div className="p-8 pb-4 flex flex-col items-center text-center">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mb-6 ring-8 ring-red-50/50">
            <AlertTriangle className="text-red-500" size={36} />
          </div>
          
          <h2 className="text-2xl font-bold text-gray-900 mb-2">{title}</h2>
          <p className="text-gray-500 leading-relaxed">
            Are you sure you want to delete <span className="font-bold text-gray-900">"{itemName}"</span>? This action is permanent and cannot be undone.
          </p>
        </div>

        <div className="p-8 pt-6 flex flex-col gap-3">
          <button
            onClick={onConfirm}
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 py-4 bg-red-500 hover:bg-red-600 text-white rounded-2xl font-bold transition-all shadow-lg shadow-red-500/25 active:scale-[0.98] disabled:opacity-50"
          >
            {loading ? <RefreshCcw size={20} className="animate-spin" /> : <Trash2 size={20} />}
            <span>{loading ? "Deleting..." : "Yes, Delete Forever"}</span>
          </button>
          
          <button
            onClick={onClose}
            disabled={loading}
            className="w-full py-4 bg-gray-50 hover:bg-gray-100 text-gray-600 rounded-2xl font-bold transition-all disabled:opacity-50"
          >
            Cancel
          </button>
        </div>

        <div className="bg-gray-50 p-4 text-center">
            <p className="text-[10px] text-gray-400 font-bold uppercase tracking-widest">Security Confirmation Required</p>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
